import { createSelector } from '@reduxjs/toolkit';

import { VerificationTemplate } from 'dashboard/models/verification-template';
import { RootState } from 'dashboard/redux/store';

const getVerificationTemplates = (state: RootState): VerificationTemplate[] =>
  state.verificationTemplates.verificationTemplates;

export const getPublishedVerificationTemplates = createSelector(
  [getVerificationTemplates],
  (verificationTemplates): Array<VerificationTemplate> =>
    verificationTemplates
      .filter((vTmpl) => vTmpl.relationships['latest-published-version'].data)
      .sort((a, b) => a.attributes.name.localeCompare(b.attributes.name)),
);
